/*
 * @Description: 
 * @Author: xiong.zhou@dmall.com
 * @Date: 2022-03-18 10:29:17
 * @LastEditors: xiong.zhou@dmall.com
 * @LastEditTime: 2024-04-10 22:39:46
 */
import request from '../request';

// 获取Banner图
export function getBanner() {
    return request('/banner/getBannerList', {
        method: 'GET'
    });
}

// 获取首页推荐列表
export function getRecommendList(params) {
    return request('/article/getShouYeRecommend', {
        method: 'GET',
        params
    });
}

// 获取首页素材推荐列表
export function getHotMaterial(params) {
    return request('/material/hot/list', {
        method: 'GET',
        params
    });
}

// 获取推荐作品列表
export function getWorkList(params) {
    return request('/zuoPin/getTuiJianZuoPinList', {
        method: 'GET',
        params
    });
}

// 获取推荐经验列表
export function getArticleList(params) {
    return request('/article/getTuiJianArticleList', {
        method: 'GET',
        params
    });
}

// 获取我的关注列表
export function getFollowList(params) {
    return request('/user/getMyAttentionUserPublish', {
        method: 'GET',
        params
    });
}

// 获取工具列表
export function getToolList() {
    return request('/sheJi/getSheJiList', {
        method: 'GET'
    });
}

// 获取精选干货
export function getJingXuanList() {
    return request('/article/getJingXuanList', {
        method: 'GET'
    });
}

// 获取设计师黄历
export function getPerCal() {
    return request('/perCal/getPerCalOnDay', {
        method: 'GET'
    });
}

// 获取首页红点
export function getUnRead() {
    return request('/home/page/red/dot', {
        method: 'GET'
    });
}
// 首页红点点击
export function readPoint(params) {
    return request('/home/page/read/dot', {
        method: 'GET',
        params
    });
}

// 获取搜索默认关键词
export function getSearchDefaultKey() {
    return request('/home/page/search', {
        method: 'GET'
    });
}
